(() => {
  const sent = new Set();

  const track = (name, properties = {}, { once = false, upgrade = false } = {}) => {
    if (once) {
      if (sent.has(name)) return;
      sent.add(name);
    }
    const detail = { page: location.pathname, ...properties };
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (upgrade) window.clarity('upgrade', name);
      }
    } catch (error) {}
    try {
      window.Shopify?.analytics?.publish?.(name, detail);
    } catch (error) {}
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
  };

  window.ovxsTrack = track;

  const forms = [
    { selector: '#OvxsAuditForm', prefix: 'audit_form', success: '.md-audit__success' },
    { selector: '#OvxsContactForm', prefix: 'contact_form', success: '.md-contact__success' },
  ];

  const init = () => {
    if (document.querySelector('#OvxsAuditForm') && !document.querySelector('.md-audit__success')) track('audit_page_viewed', {}, { once: true });

    forms.forEach(({ selector, prefix, success }) => {
      if (document.querySelector(success)) {
        track(`${prefix}_sent`, {}, { once: true, upgrade: true });
        return;
      }
      const form = document.querySelector(selector);
      if (!form) return;
      const start = () => track(`${prefix}_started`, {}, { once: true });
      form.addEventListener('focusin', start, { once: true });
      form.addEventListener('input', start, { once: true });
      form.addEventListener('submit', () => track(`${prefix}_submitted`, {}, { once: true }));
    });
  };

  document.addEventListener('click', (event) => {
    const booking = event.target.closest?.('[data-md-booking]');
    if (booking) track('book_call_clicked', { location: booking.closest('header, footer, section, [id]')?.id || '' });
    if (event.target.closest?.('[data-audit-checkout]')) track('audit_checkout_clicked', {}, { once: true });
  });

  window.addEventListener('message', (event) => {
    if (event.origin !== 'https://calendly.com' || typeof event.data?.event !== 'string') return;
    if (event.data.event === 'calendly.date_and_time_selected') track('call_time_selected', {}, { once: true });
    if (event.data.event === 'calendly.event_scheduled') track('call_booked', {}, { once: true, upgrade: true });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
